import { DateTime } from "luxon";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BlueButton } from "../../../components/attributes/Button";
import { BottomBar } from "../../../components/bar/Bottom.Bar";
import Container from "../../../components/layouts/Container";
import WrapperMiddleScreen from "../../../components/layouts/WrapperMiddleScreen";
import RenderLoading from "../../../components/loading/RenderLoading";
import { ContextLanguage } from "../../../context/Context.Language";
import api from "../../../utils/useApi";
import {
  CONSTANT_LANGUAGE,
  TEXT_AND,
  TEXT_AND_LOGIN,
  TEXT_CHANGE_COUTRY_CODE,
  TEXT_CHANGE_COUTRY_CODE_MB,
  TEXT_LOGGING_IN,
  TEXT_LOGGING_IN_MB,
  TEXT_LOG_IN,
  TEXT_NEXT,
  TEXT_ON_THE_FLAG_ICON_MB,
  TEXT_PHONE_NUMBER,
  TEXT_PRIVACY_POLICY,
  TEXT_SEND_OTP,
  TEXT_SEND_OTP_MB,
  TEXT_TERM_AND_CONDITION,
} from "../../../utils/useConstants";
import { STATE_CONSTANTS_LOGIN } from "../../../utils/useConstantState";
import { ICON_X_INPUT } from "../../../utils/useIcons";
import { useIsMobile } from "../../../utils/useIsMobile";

import {
  STLYE_INPUT_LOGIN_PHONE,
  STYLE_ADDRESS_BG,
  STYLE_BORDER_RIGHT_INPUT_PHONENUMBER,
  STYLE_BUTTON_BLUE,
  STYLE_BUTTON_BLUE_DISABLED,
  STYLE_DESCRIPTION_LOGIN_PHONE,
  STYLE_FLEX_INPUT_FOOTER,
  STYLE_HEIGHT_BAR,
  STYLE_HOVER_BLUE,
  STYLE_INPUT_FOOTER,
  STYLE_LINK_BLUE,
  STYLE_LOGIN_BAR,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_MIN_H_FULL,
  STYLE_PADDING_NO_MB,
  STYLE_SCREEN_FULL,
} from "../../../utils/useStyle";
import ProgramGoBack from "../../task/render/Program.GoBack";
import ProgramClickBack from "../../task/functions/Program.ClickBack";
import LoginNoBKB from "../function/Login.NoBKB";
import { GetPhoneNumber } from "../../../utils/useFunction";
import { ContextCart } from "../../../context/Context.Cart";

const DetailMobile = () => {
  const navigate = useNavigate();
  const { language } = React.useContext(ContextLanguage);
  return (
    <div className={STYLE_DESCRIPTION_LOGIN_PHONE(language)}>
      {/* <div>{TEXT_SEND_OTP_MB[language]}</div> */}
      {/* <div>{language === "TH" && "เบอร์โทรศัพท์ของคุณ"}</div> */}
      <div>{TEXT_CHANGE_COUTRY_CODE_MB[language]}</div>
      <div>{TEXT_ON_THE_FLAG_ICON_MB[language]}</div>

      <div>
        {TEXT_LOGGING_IN_MB[language]}
        <span
          onClick={() => navigate("/TermsAndConditions")}
          className={`${STYLE_LINK_BLUE}cursor-pointer`}
        >
          {TEXT_TERM_AND_CONDITION[language]}
        </span>
        {TEXT_AND[language]}
        <span
          onClick={() => navigate("/PrivacyNotice")}
          className={`${STYLE_LINK_BLUE}cursor-pointer`}
        >
          {TEXT_PRIVACY_POLICY[language]}
        </span>
        <div>{language === "TH" && "ของมายลอนดรี้"}</div>
      </div>
    </div>
  );
};

const DetailDesktop = () => {
  const navigate = useNavigate();
  const { language } = React.useContext(ContextLanguage);
  return (
    <div className={STYLE_DESCRIPTION_LOGIN_PHONE(language)}>
      {/* <div>{TEXT_SEND_OTP[language]}</div> */}
      <div>{TEXT_CHANGE_COUTRY_CODE[language]}</div>
      <div>{TEXT_LOGGING_IN[language]}</div>
      <div>
        <span
          onClick={() => navigate("/TermsAndConditions")}
          className={`${STYLE_LINK_BLUE} cursor-pointer`}
        >
          {TEXT_TERM_AND_CONDITION[language]}
        </span>
        {TEXT_AND_LOGIN[language]}
        <span
          onClick={() => navigate("/PrivacyNotice")}
          className={`${STYLE_LINK_BLUE} cursor-pointer`}
          title={TEXT_PRIVACY_POLICY[language]}
        >
          {TEXT_PRIVACY_POLICY[language]}
        </span>
        {language === "TH" && "ของมายลอนดรี้"}
      </div>
    </div>
  );
};

const LoginPhoneNumber = ({ setTab, contry, setValue, value }) => {
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();
  const [click, setClick] = React.useState(false);
  const { cart } = React.useContext(ContextCart);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  return (
    <div className={STYLE_SCREEN_FULL}>
      <Container>
        <div className={`max-w-desktop mx-auto md:px-10 xl:px-padding_read `}>
          <div
            className={`bg-white  md:ordershadow px-4 md:px-6 md:pb-6.5 rounded-xl h-full `}
            id="scroll_login"
          >
            <div>
              <ProgramGoBack
                onClick={() => {
                  ProgramClickBack(navigate);
                }}
                title={TEXT_LOG_IN[language]}
                // textcolor=" col-span-4 xl:col-span-1  "
              />

              <div
                className={`${STLYE_INPUT_LOGIN_PHONE} mx-auto my-4 md:mb-6 md:mt-6.5 md:w-[365px] cursor-pointer  `}
              >
                <div
                  onClick={() => {
                    setTab(STATE_CONSTANTS_LOGIN.COUNTRY_CODE);
                  }}
                  className=" group h-14 border hover:border-laundry-primary-blue border-laudry-stroke pr-[30px] mr-2 rounded-l-lg hover:bg-landry-blue-selcted"
                >
                  <div className={STYLE_FLEX_INPUT_FOOTER + ` `}>
                    <img
                      onClick={() => {
                        setTab(STATE_CONSTANTS_LOGIN.COUNTRY_CODE);
                      }}
                      className=" w-8 cursor-pointer rounded-[3px]"
                      src={contry?.image}
                    />
                    <div className="text-laudry-gray-200 group-hover:text-laundry-primary-blue ">
                      <div className="my-auto font-Poppins">
                        +{contry?.value}
                      </div>
                    </div>
                    {/* <div className={STYLE_BORDER_RIGHT_INPUT_PHONENUMBER}></div> */}
                  </div>
                </div>

                <div className=" flex justify-between items-center w-full border border-laudry-stroke border-l-0 h-14 rounded-r-lg -ml-2">
                  <input
                    id="phone_number"
                    pattern="[0-9]*"
                    type={"number"}
                    onKeyPress={async (ev) => {
                      if (ev.key === "Enter") {
                        if (click) return;

                        if (value?.length > 5) {
                          LoginNoBKB({
                            values: `+${contry?.value}${GetPhoneNumber(value)}`,
                            phoneCode: contry?.value,
                            cart,
                            dispatch,
                            navigate,
                          });
                          // setClick(true);
                          // const { data } = await api.post("/logs", {
                          //   phone_number: `+${contry?.value}${value}`,
                          //   day: DateTime.now()
                          //     .setLocale("th")
                          //     .setZone("UTC+7")
                          //     .toISO(),
                          // });
                          // if (data?.status) {
                          //   setTab(STATE_CONSTANTS_LOGIN.OTP);
                          //   setClick(false);
                          // } else {
                          //   alert(
                          //     language === "TH"
                          //       ? "You have reached the OTP limit for today"
                          //       : "You have reached the OTP limit for today"
                          //   );
                          //   setClick(false);
                          // }
                        } else {
                          alert(
                            language === "TH"
                              ? "กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง"
                              : "Please enter a valid phone number"
                          );
                        }

                        //   setTab(STATE_CONSTANTS_LOGIN.OTP);
                      }
                    }}
                    className={`${STYLE_INPUT_FOOTER} pl-[18px] text-laudry-gray-200 text-base font-Poppins `}
                    placeholder={TEXT_PHONE_NUMBER[language]}
                    value={value}
                    onChange={(e) => {
                      setValue(e.target.value);
                    }}
                  />
                  {value && (
                    <ICON_X_INPUT
                      onClick={() => setValue("")}
                      className={`${STYLE_HOVER_BLUE} text-laundry-gray-30 w-[19px] mr-3`}
                    />
                  )}
                </div>
              </div>
              {isMobile ? <DetailMobile /> : <DetailDesktop />}
            </div>
          </div>
        </div>
      </Container>

      <div className="w-full bg-white">
        <div
          className={` w-full px-4 md:px-10 xl:px-padding_read pt-4  md:py-8 bg-white  max-w-desktop mx-auto h-[106px] md:h-[124px] `}
        >
          <BlueButton
            className={
              value > 0 && !click
                ? STYLE_BUTTON_BLUE(language)
                : STYLE_BUTTON_BLUE_DISABLED(language)
            }
            title={TEXT_NEXT[language]}
            onClick={async () => {
              if (value?.length < 5) {
                alert(
                  language === "TH"
                    ? "กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง"
                    : "Please enter a valid phone number"
                );
                return;
              }
              LoginNoBKB({
                values: `+${contry?.value}${GetPhoneNumber(value)}`,
                phoneCode: contry?.value,
                cart,
                dispatch,
                navigate,
              });
              // setTab(STATE_CONSTANTS_LOGIN.OTP);
              // if (click) return;
              // if (value?.length > 5) {
              //   // setTab(STATE_CONSTANTS_LOGIN.OTP);
              //   setClick(true);
              //   const { data } = await api.post("/logs", {
              //     phone_number: `+${contry?.value}${value}`,
              //     day: new Date().toISOString(),
              //   });
              //   if (data?.status) {
              //     setTab(STATE_CONSTANTS_LOGIN.OTP);
              //     setClick(false);
              //   } else {
              //     alert(
              //       language === "TH"
              //         ? "You have reached the OTP limit for today"
              //         : "You have reached the OTP limit for today"
              //     );
              //     setClick(false);
              //   }
              // }
            }}
          />
        </div>
      </div>
    </div>
  );
  // }
};
export default LoginPhoneNumber;
